import { Drawer, Flex, Typography } from 'antd'
import { Notification } from 'entities/notification/model/types';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import classes from './NotificationDrawer.module.css';

type Props = {
  open: boolean;
  onClose: () => unknown;
  notification: Notification | null;
}

const NotificationDrawer: FC<Props> = ({ open, onClose, notification }) => {
  const { formatMessage: t } = useIntl();

  return (
    <Drawer
      title={t({ id: 'screens.setting.setting.setting.nav.notification' })}
      open={open}
      closable
      onClose={onClose}
      width={560}
    >
      <Flex vertical justify="center" align="center" gap={16}>
        <Typography.Text className={classes.title}>
          {notification && notification.parameters.title}
        </Typography.Text>
        <Typography.Text className={classes.text}>
          {notification && notification.parameters.text}
        </Typography.Text>
      </Flex>
    </Drawer>
  )
}

export default NotificationDrawer;